import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  IonApp,
  IonMenu,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonRouterOutlet,
  IonMenuToggle,
  IonIcon,
  IonButton // <--- IMPORTANTE AGREGAR ESTO
} from '@ionic/angular/standalone';
import { RouterModule, Router } from '@angular/router';
import { addIcons } from 'ionicons';
import {
  homeOutline,
  documentTextOutline,
  cashOutline,
  carOutline,
  peopleOutline,
  personOutline,
  peopleCircleOutline,
  settingsOutline,
  mapOutline,
  logOutOutline,
  createOutline // <--- NUEVO ÍCONO
} from 'ionicons/icons';
import { AuthService } from 'src/app/services/auth-service';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  imports: [
    CommonModule,
    RouterModule,
    IonApp,
    IonMenu,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonRouterOutlet,
    IonMenuToggle,
    IonIcon,
    IonButton // <--- IMPORTANTE AGREGAR ESTO
  ]
})
export class AppComponent {
  constructor(
    public auth: AuthService,
    private router: Router
  ) {
    addIcons({
      homeOutline,
      documentTextOutline,
      cashOutline,
      carOutline,
      peopleOutline,
      personOutline,
      peopleCircleOutline,
      settingsOutline,
      mapOutline,
      logOutOutline,
      createOutline // <--- REGISTRAR ÍCONO
    });
  }

  get menuItems() {
    return this.auth.getMenuItemsByRole();
  }

  get isLoggedIn(): boolean {
    return this.auth.isAuthenticated();
  }

  get userName(): string {
    return this.auth.getUser()?.username || this.auth.getUser()?.email || 'Usuario';
  }

  get roleName(): string {
    return this.auth.getRole() || '';
  }

  isLoginRoute(): boolean {
    return this.router.url === '/login';
  }

  logout() {
    this.auth.logout();
  }

  // --- NUEVA FUNCIÓN PARA EL PERFIL ---
  editarMiPerfil() {
    // Cerramos el menú (opcional) y navegamos limpiamente
    this.router.navigate(['/editar-usuario']);
  }
}